module.exports = __webpack_public_path__ + "img/p.e1ea742d.jpg";